import React from "react";
import { useNavigate } from "react-router-dom";
import { goToTop } from "./goToTop";
import { Ripple } from "primereact/ripple";

interface GoBackButtonProps {
    className?: string;
    onClick?: () => void;
}

const GoBackButton: React.FC<GoBackButtonProps> = ({
    className,
    onClick
}) => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    return (
        <button className={`back_btn p-ripple ${className ?? ''}`}
            onClick={() => {
                goBack();
                onClick?.();
            }}
        >
            <i className="bi bi-arrow-left me-2"></i>
            Back
            <Ripple />
        </button>
    )
}

export default GoBackButton;